var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightsThatMatters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.011,
    height: 58.011,
    viewBox: "0 0 58.011 58.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4146",
    d: "M0-682.665H58.011v58.011H0Z",
    transform: "translate(0 682.665)",
    fill: "#7b7bff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4140",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4142",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4144",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4150",
    transform: "translate(1.133 17.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4152",
    d: "M0,0H51.612",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4154",
    transform: "translate(7.903 7.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4156",
    d: "M-28.981-57.929a2.7,2.7,0,0,0,2.695-2.69,2.7,2.7,0,0,0-2.695-2.69,2.7,2.7,0,0,0-2.691,2.69A2.7,2.7,0,0,0-28.981-57.929Z",
    transform: "translate(31.672 63.309)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4158",
    transform: "translate(31.294 7.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4160",
    d: "M-28.981,0h10.136a2.7,2.7,0,0,1,2.691,2.69,2.7,2.7,0,0,1-2.691,2.69H-28.981a2.7,2.7,0,0,1-2.691-2.69A2.7,2.7,0,0,1-28.981,0Z",
    transform: "translate(31.672)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4162",
    transform: "translate(17.84 7.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4164",
    d: "M-28.981-57.929a2.7,2.7,0,0,0,2.695-2.69,2.7,2.7,0,0,0-2.695-2.69,2.7,2.7,0,0,0-2.691,2.69A2.7,2.7,0,0,0-28.981-57.929Z",
    transform: "translate(31.672 63.309)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4166",
    transform: "translate(16.135 26.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4168",
    d: "M-24.416,0l-2.268,9.489",
    transform: "translate(26.684)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4170",
    transform: "translate(23.624 27.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4172",
    d: "M0-83.716l3.208-3.6a.438.438,0,0,0,0-.571L0-91.49",
    transform: "translate(0 91.49)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4174",
    transform: "translate(7.598 27.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4176",
    d: "M-35.689-83.716l-3.208-3.6a.438.438,0,0,1,0-.571l3.208-3.6",
    transform: "translate(39.004 91.49)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4178",
    transform: "translate(29.964 28.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4180",
    d: "M-170.875-29.138a10.963,10.963,0,0,1,3.443,1.419l.928-.924a1.419,1.419,0,0,1,2,0l1.461,1.461a1.418,1.418,0,0,1,0,2l-.925.928a10.942,10.942,0,0,1,1.413,3.409h1.3a1.423,1.423,0,0,1,1.42,1.416v2.071a1.423,1.423,0,0,1-1.42,1.415h-1.307a10.976,10.976,0,0,1-1.407,3.39l.925.924a1.418,1.418,0,0,1,0,2L-164.5-8.161a1.419,1.419,0,0,1-2,0l-.928-.925a10.955,10.955,0,0,1-3.4,1.409V-6.36a1.423,1.423,0,0,1-1.416,1.419h-2.072A1.423,1.423,0,0,1-175.74-6.36V-7.679a10.979,10.979,0,0,1-3.4-1.406l-.925.925a1.419,1.419,0,0,1-2,0l-1.464-1.464a1.423,1.423,0,0,1,0-2l.928-.924a10.905,10.905,0,0,1-1.41-3.39h-1.314a1.42,1.42,0,0,1-1.416-1.415v-2.071a1.42,1.42,0,0,1,1.416-1.416h1.31a10.963,10.963,0,0,1,1.391-3.374l-.931-.934a1.418,1.418,0,0,1,0-2l1.461-1.461a1.419,1.419,0,0,1,2,0l.922.918a11.02,11.02,0,0,1,3.392-1.422v-1.306a1.421,1.421,0,0,1,1.416-1.419h2.068a1.424,1.424,0,0,1,1.42,1.419Z",
    transform: "translate(186.744 31.844)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4182",
    transform: "translate(37.579 36.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4184",
    d: "M-62.907,0a5.838,5.838,0,0,1,5.839,5.839,5.838,5.838,0,0,1-5.839,5.836,5.838,5.838,0,0,1-5.842-5.836A5.839,5.839,0,0,1-62.907,0Z",
    transform: "translate(68.749)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4186",
    transform: "translate(1.133 2.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4188",
    d: "M-117.651-452.519h-6.706c-2.319,0-4.22-2.269-4.22-5.04V-489.5c0-2.773,1.9-5.04,4.22-5.04h43.172c2.322,0,4.22,2.269,4.22,5.04v24.82m-21.364,12.166h-9.2",
    transform: "translate(128.577 494.544)",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4190",
    transform: "translate(17.134 44.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4192",
    d: "M0,0H.022",
    fill: "none",
    stroke: "#7b7bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsThatMatters);
export default __webpack_public_path__ + "static/media/insights-that-matters.a97a848055978df6c2e56f40df892c7f.svg";
export { ForwardRef as ReactComponent };